"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newIndividualStyles = void 0;
const lit_1 = require("lit");
exports.newIndividualStyles = (0, lit_1.css) `
    .individual-title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .new-individual-space-item {
        margin-bottom: 10px;
        margin-right: 10px;
    }
    .new-individual-row-item {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
        width: 100%;
    }
`;
